import * as RadixSwitch from "@radix-ui/react-switch";

export type SwitchProps = {
  checked?: boolean;
  onCheckedChange?: (newValue: boolean) => void;
}

export const Switch = ({ checked, onCheckedChange }: SwitchProps) => (
  <RadixSwitch.Root
    checked={checked}
    onCheckedChange={onCheckedChange}
    className="data-[state=checked]:bg-primary-100 relative h-6 w-10 cursor-pointer rounded-full bg-gray-200 outline-none">
    <RadixSwitch.Thumb className="block h-5 w-5 translate-x-0.5 rounded-full bg-white transition-transform duration-100 will-change-transform data-[state=checked]:translate-x-4.5" />
  </RadixSwitch.Root>
);
